import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockScrollingText from "./blocks/BlockScrollingText";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockSliderVertical from "./blocks/BlockSliderVertical";
import BlockStage from "./blocks/BlockStage";
import BlockTestimony from "./blocks/BlockTestimony";

import Share from "./components/Share";
import AnimationText from "./components/AnimationText";
import Section from "./components/Section";
import CtaShortcut from "./components/CtaShortcut";
import ImageAppear from "./components/ImageAppear";

import PageRealisation from "./pages/PageRealisation";
import PageAgency from "./pages/PageAgency";
import BlockHistory from "./blocks/BlockHistory";
import PageArchiveRealisation from "./pages/PageArchiveRealisation";
import BlockTestimonySlider from "./blocks/BlockTestimonySlider";
import BlockMapFrance from "./blocks/BlockMapFrance";

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	NavsFull.init();
	NavsBurger.init();

	// Blocks
	BlockBanner.init();
	BlockCollapse.init();
	BlockGallery.init();
	BlockGallerySlider.init();
	BlockGallerySliderSimple.init();
	BlockMapFrance.init();
	BlockMap.init();
	BlockMovie.init();
	BlockQuotes.init();
	BlockSlider.init();
	BlockSliderVertical.init();
	BlockScrollingText.init();
	BlockSliderScrollable.init();

	Share.init();

	AnimationText.init();
	ImageAppear.init();
	BlockHistory.init();
	BlockStage.init();
	BlockTestimony.init();
	BlockTestimonySlider.init();

	Section.init();
	CtaShortcut.init();

	PageArchiveRealisation.init();
	PageRealisation.init();
	PageAgency.init();
});
